module.exports = __webpack_public_path__ + "img/Mirta-egypt.96d0a848.png";